import * as React from "react"
import { cn } from "../../lib/utils"

const Switch = React.forwardRef(
  ({ className, checked = false, onCheckedChange, disabled = false, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        role="switch"
        aria-checked={checked}
        data-state={checked ? "checked" : "unchecked"}
        disabled={disabled}
        className={cn("ui-switch", checked && "ui-switch-checked", className)}
        onClick={() => !disabled && onCheckedChange?.(!checked)}
        {...props}
      >
        <span className={cn("ui-switch-thumb", checked && "ui-switch-thumb-checked")} />
      </button>
    )
  }
)

Switch.displayName = "Switch"

export { Switch }
